import React from 'react';
import { audiences, solutionSteps } from '../data/landingContent';
import { lessonFlow } from '../data/lessonFlow';
import { Container } from './Container';
import { Eyebrow, Highlight, SectionTitle } from './SectionHeading';
export function SolutionSection() {
  return <section className="bg-navy py-14 text-white sm:py-20 lg:py-28" data-id="element-168" data-mp="3ja7f3qupb3rp">
      <Container className="grid grid-cols-1 items-center gap-10 sm:gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-169" data-mp="3j8wajotflrzj">
        <div data-id="element-170" data-mp="12hxds2zlm27">
          <Eyebrow dark data-id="element-171" data-mp="1286m2a4bavg">Introducing School Counselor Lessons Ready™</Eyebrow>
          <SectionTitle dark data-id="element-172" data-mp="3t851s9wwwsi7">
            36 lessons. <Highlight dark data-id="element-173" data-mp="au4e23y3gdcc">One clear plan for the year.</Highlight>
          </SectionTitle>
          <p className="mt-6 text-base text-white/80 sm:text-lg" data-id="element-174" data-mp="5vkta6v8l7lk">
            Each lesson brings the hook, script, guided activity, worksheets and closing questions together — so you open the
            file, review the steps and walk into class with a plan.
          </p>

          <p className="mt-8 text-xs font-bold uppercase tracking-[0.18em] text-teal-light" data-id="element-175" data-mp="fre5fp51mz2t">Made for</p>
          <ul className="mt-3 flex flex-wrap gap-2" data-id="element-176" data-mp="36cyr4e0ytynv">
            {audiences.map(audience => <li key={audience} className="rounded-full border border-white/20 px-3.5 py-1.5 text-sm text-white/85" data-id="element-177" data-mp="3bbjsigryeodw">
                {audience}
              </li>)}
          </ul>

          <ol className="mt-10 space-y-5" data-id="element-178" data-mp="3k8am8mj19r5b">
            {solutionSteps.map((step, i) => <li key={step.title} className="flex gap-4" data-id="element-179" data-mp="3p984t07ygn7c" data-mpi={i}>
                <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-teal font-condensed text-xl font-extrabold" data-id="element-180" data-mp="3u7jbx36v8jlv">
                  {i + 1}
                </span>
                <div data-id="element-181" data-mp="6w0g191utt92">
                  <h3 className="font-condensed text-[22px] font-bold uppercase leading-tight" data-id="element-182" data-mp="6u78zsnbx70j">{step.title}</h3>
                  <p className="text-[15px] text-white/70" data-id="element-183" data-mp="bw517cdpjc5m">{step.text}</p>
                </div>
              </li>)}
          </ol>
        </div>

        <div data-id="element-184" data-mp="2cw9wcwa72j3l">
          <div className="rounded-2xl bg-white p-5 text-ink shadow-[0_30px_60px_rgba(0,0,0,0.25)] sm:p-8" data-id="element-185" data-mp="2cw1l18tpzlui">
            <div className="flex justify-between gap-4 border-b-2 border-teal pb-3 text-[11px] font-bold uppercase tracking-[0.16em] text-teal" data-id="element-186" data-mp="27yrjiut23jqb">
              <span data-id="element-187" data-mp="2mofnk3smgwhq">Example lesson flow</span>
              <span data-id="element-188" data-mp="2hvmkrlgpry8a">30 minutes</span>
            </div>
            <h3 className="my-5 font-condensed text-[34px] font-extrabold uppercase leading-none text-navy" data-id="element-189" data-mp="2hu2zfgg7awzn">Name That Feeling</h3>
            <ol data-id="element-190" data-mp="2rm8tcvq0johh">
              {lessonFlow.map(step => <li key={step.label} className="grid grid-cols-[52px_1fr] gap-3 border-t border-line py-3 text-[13px] sm:grid-cols-[60px_1fr] sm:gap-4 sm:text-sm" data-id="element-191" data-mp="2rnsbkrv8c9lw">
                  <strong className="font-condensed text-lg leading-tight text-teal" data-id="element-192" data-mp="30np1ewtcveij">{step.time}</strong>
                  <span data-id="element-193" data-mp="1b7zf4ufhjg4d">
                    <b className="text-navy" data-id="element-194" data-mp="1b9jzjr835ioi">{step.label}</b>
                    <br data-id="element-195" data-mp="169eb0jx44can" />
                    <span className="text-muted" data-id="element-196" data-mp="16a7b521kg3jt">{step.detail}</span>
                  </span>
                </li>)}
            </ol>
            <div className="mt-4 rounded-xl bg-teal-soft p-4 text-sm text-ink" data-id="element-197" data-mp="3mvcdn0za31o5">
              <strong className="mb-1.5 block text-[10px] uppercase tracking-[0.16em] text-teal" data-id="element-198" data-mp="385wmvkzqyw8g">Example teaching language</strong>
              “Two people can feel differently about the same thing. What might this character feel? What clue helped you choose?”
            </div>
          </div>
          <p className="mt-4 text-center text-xs text-white/60" data-id="element-199" data-mp="2z7kxtnej46i4">Illustrative lesson flow; not a screenshot of the finished PDF.</p>
        </div>
      </Container>
    </section>;
}